import { HIRING_RELIABILITY_CONFIG } from "@clipboard-health/contract-backend-main";
import { Box, Stack } from "@mui/material";
import { formatTime } from "@src/appV2/redesign/utils/formatTime";

import { ListHelper } from "./ListHelper";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface ReliabilityRuleSectionProps {
  workplaceStartHour: Date;
}

export function ReliabilityRuleSection(props: ReliabilityRuleSectionProps) {
  const { workplaceStartHour } = props;

  return (
    <PlacementSectionTemplate title="Attendance Policy" iconType="triangle-exclamation">
      <Stack spacing={6}>
        <ListHelper>
          <ListHelper.Item>
            <ListHelper.Text>
              You can cancel or reschedule up{" "}
              <Box component="span" sx={{ fontWeight: 600 }}>
                until {formatTime(workplaceStartHour)}
              </Box>{" "}
              on the day of the interview.{" "}
              <Box component="span" sx={{ fontWeight: 600 }}>
                After {formatTime(workplaceStartHour)}
              </Box>
              , if you cancel or no-show, you&apos;ll be restricted from viewing jobs for{" "}
              {HIRING_RELIABILITY_CONFIG.RESTRICTED_DAYS} days.
            </ListHelper.Text>
          </ListHelper.Item>
          <ListHelper.Item>
            <ListHelper.Text>
              Job restrictions do not apply to shifts. You&apos;re free to work shifts if your
              Clipboard Score is in good standing.
            </ListHelper.Text>
          </ListHelper.Item>
        </ListHelper>
      </Stack>
    </PlacementSectionTemplate>
  );
}
